class Preloader {

  constructor(elem) {
    this.preloader = elem;
  }

  initialize() {
    this.preloader.delay(350).fadeOut('slow');
  }

  setPreloader() {
    this.preloader.fadeIn('slow');
  }

  removePreloader() {
    this.preloader.fadeOut('slow');
  }
}

export {Preloader};

$(window).on('load', () => {
  let preloader = [];
  if ($('[data-preloader]').length > 0) {
    $('[data-preloader]').each(function(i) {
			preloader[i] = new Preloader($(this));
			preloader[i].initialize();
    })
  }
})
